import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import Swal from "sweetalert2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { communication } from "../../services/communication";
import { faCircleLeft } from "@fortawesome/free-solid-svg-icons";
import Loader from "../Loader";
import { useNavigate, useSearchParams } from "react-router-dom";

const UpdateUser = () => {
  const router = useNavigate();
  const [searchParams] = useSearchParams()
  const [disabled, setDisabled] = useState(true)
  const [loader, setLoader] = useState(false);
  const [data, setData] = useState({})
  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    watch,
    formState: { errors },
  } = useForm({
    mode: "onChange",
  });



  const onSubmit = async (data) => {
    try {
      setLoader(true);
      const responseFromServer = await communication.updateUser({
        id: searchParams.get("userId"),
        ...data,
      });
      if (responseFromServer?.data?.status === "SUCCESS") {
        setLoader(false);
        router("/main-panel/user-management");
        Swal.fire({ text: responseFromServer?.data?.message, icon: "success" });
      } else if (responseFromServer?.data?.status === "JWT_INVALID") {
        setLoader(false);
        Swal.fire({ text: responseFromServer?.data?.message, icon: "warning" });
        router("/login");
      } else {
        setLoader(false);
        Swal.fire({ text: responseFromServer?.data?.message, icon: "warning" });
      }
    } catch (error) {
      setLoader(false);
      Swal.fire({ text: error?.response?.data?.message || error.message, icon: "warning" });
    }
  };

  async function getUserById() {
    try {
      setLoader(true);
      const responseFromServer = await communication.getuserById(searchParams.get("id"));
      if (responseFromServer?.data?.status === true) {
        setData(responseFromServer?.data?.data ?? {})
        setValue("name", responseFromServer?.data?.data?.personalDetails?.name ?? "--");

        setValue("address", responseFromServer?.data?.data?.personalDetails?.address ?? "--");
        setValue("city_PostOffice", responseFromServer?.data?.data?.personalDetails?.city_PostOffice ?? "--");
        setValue("district", responseFromServer?.data?.data?.personalDetails?.district ?? "--");
        setValue("state", responseFromServer?.data?.data?.personalDetails?.state ?? "--");
        setValue("pinCode", responseFromServer?.data?.data?.personalDetails?.pinCode ?? "--");
        setValue("mobileNumber", responseFromServer?.data?.data?.personalDetails?.mobileNumber ?? "--");
        setValue("emailId", responseFromServer?.data?.data?.personalDetails?.emailId ?? "--");
        setValue("gender", responseFromServer?.data?.data?.personalDetails?.gender ?? "--");
        setValue("dob", responseFromServer?.data?.data?.personalDetails?.dob ?? "--");
        setValue("pan", responseFromServer?.data?.data?.personalDetails?.pan ?? "--");
        setValue("aadhaarNumber", responseFromServer?.data?.data?.personalDetails?.aadhaarNumber ?? "--");
        setValue("category", responseFromServer?.data?.data?.personalDetails?.category ?? "--");
        setValue("bplOrDaStatus", responseFromServer?.data?.data?.personalDetails?.bplOrDaStatus ?? "--");
        setValue("bplOrDaType", responseFromServer?.data?.data?.personalDetails?.bplOrDaType ?? "--");

        setValue("highEducationQualification", responseFromServer?.data?.data?.educationalDetails?.highEducationQualification ?? "--");
        setValue("disciplineForQualification", responseFromServer?.data?.data?.educationalDetails?.disciplineForQualification ?? "--");

        setValue("presentOccupation", responseFromServer?.data?.data?.occupationDetails?.presentOccupation ?? "--");
        setValue("specifyNature", responseFromServer?.data?.data?.occupationDetails?.specifyNature ?? "--");
        setValue("registrationNumber", responseFromServer?.data?.data?.occupationDetails?.registrationNumber ?? "--");


        setValue("areaOfIncubation", responseFromServer?.data?.data?.otherDetails?.areaOfIncubation ?? "--");
        setValue("describeIdea", responseFromServer?.data?.data?.otherDetails?.describeIdea ?? "--");
        setValue("incubationServices", responseFromServer?.data?.data?.otherDetails?.incubationServices ?? "--");
        setValue("modeOfIncubation", responseFromServer?.data?.data?.otherDetails?.modeOfIncubation ?? "--");
        setValue("durationOfIncubation", responseFromServer?.data?.data?.otherDetails?.durationOfIncubation ?? "--");

      } else if (responseFromServer?.data?.status === "JWT_INVALID") {
        Swal.fire({ text: responseFromServer?.data?.message, icon: "warning" });
        Swal.fire({ text: responseFromServer?.data?.message, icon: "warning" });
        router("/login");
      } else {
        Swal.fire({ text: responseFromServer?.data?.message, icon: "warning" });
      }
    } catch (error) {
      Swal.fire({ text: error?.response?.data?.message || error.message, icon: "warning" });
    } finally {
      setLoader(false);
    }
  }
  console.log("data", data);

  const deleteUser = async () => {

    const confirmation = await Swal.fire({
      text: "Do you really want to delete this User?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    });

    if (confirmation.isConfirmed) {
      try {
        setLoader(true);
        const response = await communication.deleteUser(searchParams.get("id"));

        if (response?.data?.status === "SUCCESS") {
          Swal.fire({ text: response.data.message, icon: "success" });
          // await getUserList(currentPage, searchString);
          router("/main-panel/user-management");
        } else {
          Swal.fire({
            text: response.data.message || "Deletion failed",
            icon: "error",
          });
        }
      } catch (error) {
        Swal.fire({
          text: error?.response?.data?.message || error.message,
          icon: "warning",
        });
      } finally {
        setLoader(false);
      }
    }
  };

  // userStatus
  async function changeUserStatus(status) {
    try {
      let obj = {
        rejected: "Reject",
        accepted: "Accept"
      }
      const confirmation = await Swal.fire({
        text: `Do you really want to ${obj[status]} form?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      });

      if (!confirmation.isConfirmed) {
        return; // Exit if the user cancels the action
      }

      let reason = "";
      if (status === "rejected") {
        const { value: rejectionReason, isConfirmed } = await Swal.fire({
          title: "Reason for Rejection",
          input: "textarea",
          inputPlaceholder: "Enter rejection reason here...",
          showCancelButton: true,
          confirmButtonText: "Submit",
          cancelButtonText: "Cancel",
        });
        if (!isConfirmed) {
          return
        }
        if (!rejectionReason) {
          Swal.fire({ text: "Rejection reason is required.", icon: "error" });
          return;
        }
        reason = rejectionReason;
      }

      setLoader(true);
      const id = searchParams.get("id");

      if (!id) {
        Swal.fire({ text: "User ID not found.", icon: "error" });
        return;
      }

      const data = { _id: id, formStatus: status, reason };
      const response = await communication.updateUserStatus(data);

      switch (response?.data?.status) {
        case "SUCCESS":
          Swal.fire({
            text: response?.data?.message || "Status updated successfully!",
            icon: "success",
          });
          router("/main-panel/user-management");
          break;

        case "JWT_INVALID":
          Swal.fire({
            text: response?.data?.message || "Invalid session. Please log in again.",
            icon: "warning",
          });
          router("/login");
          break;

        default:
          Swal.fire({
            text: response?.data?.message || "Failed to update status.",
            icon: "warning",
          });
          break;
      }
    } catch (error) {
      Swal.fire({
        text: error?.response?.data?.message || error.message || "An unexpected error occurred.",
        icon: "warning",
      });
    } finally {
      setLoader(false);
    }
  }



  useEffect(() => {
    getUserById();
  }, []);

  return (
    <>
      {loader ? (
        <Loader />
      ) : (
        <div className="add_update_form_wrapper">
          <div className="add_update_form_main position-relative">
            <div
              title="Go back"
              onClick={() => router("/main-panel/user-management")}
              className="User_back_icon"
            >
              <FontAwesomeIcon icon={faCircleLeft} />
            </div>

            <div className="add_update_form_section">
              <div className="add_update_heading">
                <h4 style={{ marginTop: "15px" }}>Form Details</h4>
              </div>


              <div className="head_direction">
                <h5 className="right_side_Heading">Personal Details</h5>
                <h5 className="left_side_Heading">Identity Details</h5>
              </div>

              <div className="d-flex">

                <div style={{ border: "1px solid #ec571c", width: "49%", borderRadius: "0.4rem", marginRight: "18px", paddingBottom: "12px" }}>
                  <div className="input_main_wrapper" style={{ justifyContent: "center" }}>
                    <div className="input_col">
                      <div className="label_div">
                        <label>User Name :</label>
                      </div>
                      <div className="input_div">
                        <input
                          style={{ border: "none" }}
                          disabled={disabled}
                          {...register("name", {
                            // required: "User Name is required",
                            // pattern: {
                            //   value: /^[A-Za-z\s]+$/,
                            //   message: "User Name should contain only letters",
                            // },
                          })}
                          // placeholder={"Enter User Name"}
                          type="text"
                          className="form-control input login_input"
                        />
                        <div className="error-message">
                          {errors?.name && (
                            <p className="text-danger text-start" style={{ fontSize: "0.8rem" }}>
                              {errors?.name.message}
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="input_main_wrapper" style={{ justifyContent: "center" }}>
                    <div className="input_col">
                      <div className="label_div">
                        <label>Address :</label>
                      </div>
                      <div className="input_div">
                        <input
                          style={{ border: "none" }}
                          disabled={disabled}
                          {...register("address", {
                            // required: "User Name is required",
                            // pattern: {
                            //   value: /^[A-Za-z\s]+$/,
                            //   message: "User Name should contain only letters",
                            // },
                          })}
                          // placeholder={"Enter User Name"}
                          type="text"
                          className="form-control input login_input"
                        />
                        <div className="error-message">
                          {errors?.address && (
                            <p className="text-danger text-start" style={{ fontSize: "0.8rem" }}>
                              {errors?.address.message}
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="input_main_wrapper" style={{ justifyContent: "center" }}>
                    <div className="input_col">
                      <div className="label_div">
                        <label>City Post Office :</label>
                      </div>
                      <div className="input_div">
                        <input
                          style={{ border: "none" }}
                          disabled={disabled}
                          {...register("city_PostOffice", {
                            // required: "User Name is required",
                            // pattern: {
                            //   value: /^[A-Za-z\s]+$/,
                            //   message: "User Name should contain only letters",
                            // },
                          })}
                          // placeholder={"Enter User Name"}
                          type="text"
                          className="form-control input login_input"
                        />
                        <div className="error-message">
                          {errors?.city_PostOffice && (
                            <p className="text-danger text-start" style={{ fontSize: "0.8rem" }}>
                              {errors?.city_PostOffice.message}
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="input_main_wrapper" style={{ justifyContent: "center" }}>
                    <div className="input_col">
                      <div className="label_div">
                        <label>District :</label>
                      </div>
                      <div className="input_div">
                        <input
                          style={{ border: "none" }}
                          disabled={disabled}
                          {...register("district", {
                            // required: "User Name is required",
                            // pattern: {
                            //   value: /^[A-Za-z\s]+$/,
                            //   message: "User Name should contain only letters",
                            // },
                          })}
                          // placeholder={"Enter User Name"}
                          type="text"
                          className="form-control input login_input"
                        />
                        <div className="error-message">
                          {errors?.district && (
                            <p className="text-danger text-start" style={{ fontSize: "0.8rem" }}>
                              {errors?.district.message}
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="input_main_wrapper" style={{ justifyContent: "center" }}>
                    <div className="input_col">
                      <div className="label_div">
                        <label>State :</label>
                      </div>
                      <div className="input_div">
                        <input
                          style={{ border: "none" }}
                          disabled={disabled}
                          {...register("state", {
                            // required: "User Name is required",
                            // pattern: {
                            //   value: /^[A-Za-z\s]+$/,
                            //   message: "User Name should contain only letters",
                            // },
                          })}
                          // placeholder={"Enter User Name"}
                          type="text"
                          className="form-control input login_input"
                        />
                        <div className="error-message">
                          {errors?.state && (
                            <p className="text-danger text-start" style={{ fontSize: "0.8rem" }}>
                              {errors?.state.message}
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="input_main_wrapper" style={{ justifyContent: "center" }}>
                    <div className="input_col">
                      <div className="label_div">
                        <label>PinCode :</label>
                      </div>
                      <div className="input_div">
                        <input
                          style={{ border: "none" }}
                          disabled={disabled}
                          {...register("pinCode", {
                            // required: "User Name is required",
                            // pattern: {
                            //   value: /^[A-Za-z\s]+$/,
                            //   message: "User Name should contain only letters",
                            // },
                          })}
                          // placeholder={"Enter User Name"}
                          type="text"
                          className="form-control input login_input"
                        />
                        <div className="error-message">
                          {errors?.pinCode && (
                            <p className="text-danger text-start" style={{ fontSize: "0.8rem" }}>
                              {errors?.pinCode.message}
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="input_main_wrapper" style={{ justifyContent: "center" }}>
                    <div className="input_col">
                      <div className="label_div">
                        <label>Mobile Number :</label>
                      </div>
                      <div className="input_div">
                        <input
                          style={{ border: "none" }}
                          disabled={disabled}
                          {...register("mobileNumber",
                            {
                              // required: "Mobile Number is required",
                              // pattern: {
                              //   value: /^\+?(\d{1,3})?[-.\s]?\(?\d{3}\)?[-.\s]?\d{3}[-.\s]?\d{4}$/,
                              //   message: "Please enter a valid mobile number",
                              // },
                              // minLength: {
                              //   value: 10,
                              //   message: "Mobile Number should be 10 characters",
                              // },
                              // maxLength: {
                              //   value: 10,
                              //   message: "Mobile Number should be 10 characters",
                              // },
                            })}
                          // placeholder={"Enter Mobile Number"}
                          type="number"
                          className="form-control input login_input"
                        />
                        <div className="error-message">
                          {errors.mobile && (
                            <p className="text-danger text-start" style={{ fontSize: "0.8rem" }}>
                              {errors.mobileNumber.message}
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="input_main_wrapper" style={{ justifyContent: "center" }}>
                    <div className="input_col">
                      <div className="label_div">
                        <label>Email Id :</label>
                      </div>
                      <div className="input_div">
                        <input
                          style={{ border: "none" }}
                          disabled={disabled}
                          {...register("emailId", {
                            // required: "User Name is required",
                            // pattern: {
                            //   value: /^[A-Za-z\s]+$/,
                            //   message: "User Name should contain only letters",
                            // },
                          })}
                          // placeholder={"Enter User Name"}
                          type="text"
                          className="form-control input login_input"
                        />
                        <div className="error-message">
                          {errors?.emailId && (
                            <p className="text-danger text-start" style={{ fontSize: "0.8rem" }}>
                              {errors?.emailId.message}
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="input_main_wrapper" style={{ justifyContent: "center" }}>
                    <div className="input_col">
                      <div className="label_div">
                        <label>Gender :</label>
                      </div>
                      <div className="input_div">
                        <input
                          style={{ border: "none" }}
                          disabled={disabled}
                          {...register("gender", {
                            // required: "User Name is required",
                            // pattern: {
                            //   value: /^[A-Za-z\s]+$/,
                            //   message: "User Name should contain only letters",
                            // },
                          })}
                          // placeholder={"Enter User Name"}
                          type="text"
                          className="form-control input login_input"
                        />
                        <div className="error-message">
                          {errors?.gender && (
                            <p className="text-danger text-start" style={{ fontSize: "0.8rem" }}>
                              {errors?.gender.message}
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="input_main_wrapper" style={{ justifyContent: "center" }}>
                    <div className="input_col">
                      <div className="label_div">
                        <label>DOB :</label>
                      </div>
                      <div className="input_div">
                        <input
                          style={{ border: "none" }}
                          disabled={disabled}
                          {...register("dob", {
                            // required: "User Name is required",
                            // pattern: {
                            //   value: /^[A-Za-z\s]+$/,
                            //   message: "User Name should contain only letters",
                            // },
                          })}
                          // placeholder={"Enter User Name"}
                          type="text"
                          className="form-control input login_input"
                        />
                        <div className="error-message">
                          {errors?.dob && (
                            <p className="text-danger text-start" style={{ fontSize: "0.8rem" }}>
                              {errors?.dob.message}
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div style={{ height: "110px", border: "1px solid #ec571c", width: "49%", borderRadius: "0.4rem" }}>
                  <div className="input_main_wrapper" style={{ justifyContent: "center" }}>
                    <div className="input_col">
                      <div className="label_div">
                        <label>Pan :</label>
                      </div>
                      <div className="input_div">
                        <input
                          style={{ border: "none" }}
                          disabled={disabled}
                          {...register("pan", {
                            // required: "User Name is required",
                            // pattern: {
                            //   value: /^[A-Za-z\s]+$/,
                            //   message: "User Name should contain only letters",
                            // },
                          })}
                          // placeholder={"Enter User Name"}
                          type="text"
                          className="form-control input login_input"
                        />
                        <div className="error-message">
                          {errors?.pan && (
                            <p className="text-danger text-start" style={{ fontSize: "0.8rem" }}>
                              {errors?.pan.message}
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="input_main_wrapper" style={{ justifyContent: "center" }}>
                    <div className="input_col">
                      <div className="label_div">
                        <label>Aadhaar Number :</label>
                      </div>
                      <div className="input_div">
                        <input
                          style={{ border: "none" }}
                          disabled={disabled}
                          {...register("aadhaarNumber", {
                            // required: "User Name is required",
                            // pattern: {
                            //   value: /^[A-Za-z\s]+$/,
                            //   message: "User Name should contain only letters",
                            // },
                          })}
                          // placeholder={"Enter User Name"}
                          type="text"
                          className="form-control input login_input"
                        />
                        <div className="error-message">
                          {errors?.aadhaarNumber && (
                            <p className="text-danger text-start" style={{ fontSize: "0.8rem" }}>
                              {errors?.aadhaarNumber.message}
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="head_direction">
                <h5 className="category_Heading">Category Details</h5>
                <h5 className="left_side_Heading employee_head">Employment Information</h5>
              </div>

              <div className="d-flex">
                <div className="category_details" style={{ border: "1px solid #ec571c", width: "49%", borderRadius: "0.4rem", marginRight: "18px" }}>
                  <div className="input_main_wrapper" style={{ justifyContent: "center" }}>
                    <div className="input_col">
                      <div className="label_div">
                        <label>Category :</label>
                      </div>
                      <div className="input_div">
                        <input
                          style={{ border: "none" }}
                          disabled={disabled}
                          {...register("category", {
                            // required: "User Name is required",
                            // pattern: {
                            //   value: /^[A-Za-z\s]+$/,
                            //   message: "User Name should contain only letters",
                            // },
                          })}
                          // placeholder={"Enter User Name"}
                          type="text"
                          className="form-control input login_input"
                        />
                        <div className="error-message">
                          {errors?.category && (
                            <p className="text-danger text-start" style={{ fontSize: "0.8rem" }}>
                              {errors?.category.message}
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="input_main_wrapper" style={{ justifyContent: "center" }}>
                    <div className="input_col">
                      <div className="label_div">
                        <label>BPL Or DA Type :</label>
                      </div>
                      <div className="input_div">
                        <input
                          style={{ border: "none" }}
                          disabled={disabled}
                          {...register("bplOrDaType", {
                            // required: "User Name is required",
                            // pattern: {
                            //   value: /^[A-Za-z\s]+$/,
                            //   message: "User Name should contain only letters",
                            // },
                          })}
                          // placeholder={"Enter User Name"}
                          type="text"
                          className="form-control input login_input"
                        />
                        <div className="error-message">
                          {errors?.bplOrDaType && (
                            <p className="text-danger text-start" style={{ fontSize: "0.8rem" }}>
                              {errors?.bplOrDaType.message}
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="sec_div_Position" style={{ height: "110px", border: "1px solid #ec571c", width: "49%", borderRadius: "0.4rem" }}>
                  <div className="input_main_wrapper" style={{ justifyContent: "center" }}>
                    <div className="input_col">
                      <div className="label_div">
                        <label>Present Occupation :</label>
                      </div>
                      <div className="input_div">
                        <input
                          style={{ border: "none" }}
                          disabled={disabled}
                          {...register("presentOccupation", {
                            // required: "User Name is required",
                            // pattern: {
                            //   value: /^[A-Za-z\s]+$/,
                            //   message: "User Name should contain only letters",
                            // },
                          })}
                          // placeholder={"Enter User Name"}
                          type="text"
                          className="form-control input login_input"
                        />
                        <div className="error-message">
                          {errors?.presentOccupation && (
                            <p className="text-danger text-start" style={{ fontSize: "0.8rem" }}>
                              {errors?.presentOccupation.message}
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="input_main_wrapper" style={{ justifyContent: "center" }}>
                    <div className="input_col">
                      <div className="label_div">
                        <label>Specify Nature :</label>
                      </div>
                      <div className="input_div">
                        <input
                          style={{ border: "none" }}
                          disabled={disabled}
                          {...register("specifyNature", {
                            // required: "User Name is required",
                            // pattern: {
                            //   value: /^[A-Za-z\s]+$/,
                            //   message: "User Name should contain only letters",
                            // },
                          })}
                          // placeholder={"Enter User Name"}
                          type="text"
                          className="form-control input login_input"
                        />
                        <div className="error-message">
                          {errors?.specifyNature && (
                            <p className="text-danger text-start" style={{ fontSize: "0.8rem" }}>
                              {errors?.specifyNature.message}
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <div className="head_direction">
                <h5 className="education_head">Educatinal Background</h5>
                <h5 className="encubation_head">Incubation Details</h5>
              </div>

              <div className="d-flex ">
                <div className="incubation_left_head" style={{ height: "140px", border: "1px solid #ec571c", width: "49%", borderRadius: "0.4rem", marginRight: "18px" }}>
                  <div className="input_main_wrapper" style={{ justifyContent: "center" }}>
                    <div className="input_col">
                      <div className="label_div">
                        <label>Education Qualification :</label>
                      </div>
                      <div className="input_div">
                        <input
                          style={{ border: "none" }}
                          disabled={disabled}
                          {...register("highEducationQualification", {
                            // required: "User Name is required",
                            // pattern: {
                            //   value: /^[A-Za-z\s]+$/,
                            //   message: "User Name should contain only letters",
                            // },
                          })}
                          // placeholder={"Enter User Name"}
                          type="text"
                          className="form-control input login_input"
                        />
                        <div className="error-message">
                          {errors?.highEducationQualification && (
                            <p className="text-danger text-start" style={{ fontSize: "0.8rem" }}>
                              {errors?.highEducationQualification.message}
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="input_main_wrapper" style={{ justifyContent: "center" }}>
                    <div className="input_col">
                      <div className="label_div">
                        <label>Discipline For Qualification :</label>
                      </div>
                      <div className="input_div">
                        <input
                          style={{ border: "none" }}
                          disabled={disabled}
                          {...register("disciplineForQualification", {
                            // required: "User Name is required",
                            // pattern: {
                            //   value: /^[A-Za-z\s]+$/,
                            //   message: "User Name should contain only letters",
                            // },
                          })}
                          // placeholder={"Enter User Name"}
                          type="text"
                          className="form-control input login_input"
                        />
                        <div className="error-message">
                          {errors?.disciplineForQualification && (
                            <p className="text-danger text-start" style={{ fontSize: "0.8rem" }}>
                              {errors?.disciplineForQualification.message}
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="incubation_details" style={{ border: "1px solid #ec571c", width: "49%", borderRadius: "0.4rem", paddingBottom: "12px" }}>
                  <div className="input_main_wrapper" style={{ justifyContent: "center" }}>
                    <div className="input_col">
                      <div className="label_div">
                        <label>Registration Number :</label>
                      </div>
                      <div className="input_div">
                        <input
                          style={{ border: "none" }}
                          disabled={disabled}
                          {...register("registrationNumber", {
                            // required: "User Name is required",
                            // pattern: {
                            //   value: /^[A-Za-z\s]+$/,
                            //   message: "User Name should contain only letters",
                            // },
                          })}
                          // placeholder={"Enter User Name"}
                          type="text"
                          className="form-control input login_input"
                        />
                        <div className="error-message">
                          {errors?.registrationNumber && (
                            <p className="text-danger text-start" style={{ fontSize: "0.8rem" }}>
                              {errors?.registrationNumber.message}
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="input_main_wrapper" style={{ justifyContent: "center" }}>
                    <div className="input_col">
                      <div className="label_div">
                        <label style={{ minHeight: "100px" }}>Area Of Incubation :</label>
                      </div>
                      <div className="input_div">
                        <textarea
                          style={{
                            border: "none",
                            backgroundColor: "white",
                            // minHeight: "100px",
                            height: "auto",
                            // overflow: "hidden",
                            resize: "none",
                            color: "gray",
                          }}
                          rows={4}
                          disabled={disabled}
                          {...register("areaOfIncubation", {
                            // required: "User Name is required",
                            // pattern: {
                            //   value: /^[A-Za-z\\s]+$/,
                            //   message: "User Name should contain only letters",
                            // },
                          })}
                          className="form-control input login_input"
                          onInput={(e) => {
                            e.target.style.height = "auto"; // Reset height
                            e.target.style.height = `${e.target.scrollHeight}px`; // Adjust based on content
                          }}
                        />

                        <div className="error-message">
                          {errors?.areaOfIncubation && (
                            <p className="text-danger text-start" style={{ fontSize: "0.8rem" }}>
                              {errors?.areaOfIncubation.message}
                            </p>
                          )}
                        </div>
                      </div>

                    </div>
                  </div>
                  <div className="input_main_wrapper" style={{ justifyContent: "center" }}>
                    <div className="input_col">
                      <div className="label_div">
                        <label>Describe Idea :</label>
                      </div>
                      <div className="input_div">
                        <input
                          style={{ border: "none" }}
                          disabled={disabled}
                          {...register("describeIdea", {
                            // required: "User Name is required",
                            // pattern: {
                            //   value: /^[A-Za-z\s]+$/,
                            //   message: "User Name should contain only letters",
                            // },
                          })}
                          // placeholder={"Enter User Name"}
                          type="text"
                          className="form-control input login_input"
                        />
                        <div className="error-message">
                          {errors?.describeIdea && (
                            <p className="text-danger text-start" style={{ fontSize: "0.8rem" }}>
                              {errors?.describeIdea.message}
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="input_main_wrapper" style={{ justifyContent: "center" }}>
                    <div className="input_col">
                      <div className="label_div">
                        <label style={{ minHeight: "100px" }}>Incubation Services :</label>
                      </div>
                      <div className="input_div">
                        <textarea
                          style={{
                            border: "none",
                            backgroundColor: "white",
                            // minHeight: "100px",
                            height: "auto",
                            // overflow: "hidden",
                            resize: "none",
                            color: "gray",
                          }}
                          rows={4}
                          disabled={disabled}
                          {...register("incubationServices", {
                            // required: "User Name is required",
                            // pattern: {
                            //   value: /^[A-Za-z\s]+$/,
                            //   message: "User Name should contain only letters",
                            // },
                          })}
                          // placeholder={"Enter User Name"}
                          type="text"
                          className="form-control input login_input"
                        />
                        <div className="error-message">
                          {errors?.incubationServices && (
                            <p className="text-danger text-start" style={{ fontSize: "0.8rem" }}>
                              {errors?.incubationServices.message}
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="input_main_wrapper" style={{ justifyContent: "center" }}>
                    <div className="input_col">
                      <div className="label_div">
                        <label>Mode Of Incubation :</label>
                      </div>
                      <div className="input_div">
                        <input
                          style={{ border: "none" }}
                          disabled={disabled}
                          {...register("modeOfIncubation", {
                            // required: "User Name is required",
                            // pattern: {
                            //   value: /^[A-Za-z\s]+$/,
                            //   message: "User Name should contain only letters",
                            // },
                          })}
                          // placeholder={"Enter User Name"}
                          type="text"
                          className="form-control input login_input"
                        />
                        <div className="error-message">
                          {errors?.modeOfIncubation && (
                            <p className="text-danger text-start" style={{ fontSize: "0.8rem" }}>
                              {errors?.modeOfIncubation.message}
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="input_main_wrapper" style={{ justifyContent: "center" }}>
                    <div className="input_col">
                      <div className="label_div">
                        <label>Duration Of Incubation :</label>
                      </div>
                      <div className="input_div">
                        <input
                          style={{ border: "none" }}
                          disabled={disabled}
                          {...register("durationOfIncubation", {
                            // required: "User Name is required",
                            // pattern: {
                            //   value: /^[A-Za-z\s]+$/,
                            //   message: "User Name should contain only letters",
                            // },
                          })}
                          // placeholder={"Enter User Name"}
                          type="text"
                          className="form-control input login_input"
                        />
                        <div className="error-message">
                          {errors?.durationOfIncubation && (
                            <p className="text-danger text-start" style={{ fontSize: "0.8rem" }}>
                              {errors?.durationOfIncubation.message}
                            </p>
                          )}

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                
              </div>
            
 

              {/* submit and cancel button for add user page*/}
              <div className="button_wrapper_accept">
              <div className="label_div">
                {(data?.formStatus?.toLowerCase() === "rejected" && data?.reason) &&
                  <p> <span> Rejected Reason :</span>  {data?.reason ?? ""} </p>
                }
              </div>
              <div>
                
              </div>
                <div className="button_col">
                  <button
                    onClick={() => changeUserStatus("accepted")}
                    className="btn btn-primary cancel_button"
                    style={{ backgroundColor: "#ec571c", color: "white", border: "none" }}
                  >
                    Accept
                  </button>
                </div>
                <div className="button_col">
                  <button
                    onClick={() => changeUserStatus("rejected")}
                    className="btn btn-primary cancel_button"
                    style={{ backgroundColor: "rgb(169 31 44)", color: "white", border: "none" }}
                  >
                    Reject
                  </button>
                </div>
                <div className="button_col">
                  <button
                    onClick={(event) => deleteUser()}
                    className="btn btn-primary cancel_button"
                    style={{ backgroundColor: "#ff0000d1", color: "white", border: "none" }}
                  >
                    Delete
                  </button>
                </div>
                <div className="button_col">
                  <button
                    onClick={() => router("/main-panel/user-management")}
                    className="btn btn-primary cancel_button"
                  >
                    Back
                  </button>
                </div>
              </div>


             
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default UpdateUser;



